module.exports = __webpack_public_path__ + "img/8.570b3b04.jpg";